import { Input, Label } from "reactstrap";
import { UserFormGroup } from "../../../../../types/Applications";

const CommonUserFormGroup:React.FC<UserFormGroup> = ({ type, title, placeholder,defaultValue,row }) => {
  return (
    <div className="mb-3">
      <Label>{title}</Label>
      <Input type={type} placeholder={placeholder} defaultValue={defaultValue} rows={row} />
    </div>
  );
};

export default CommonUserFormGroup;
